import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('VideoExercise', LATEST_SCHEMA_VERSION.VideoExercise);
export default exerciseTypeVersionAdapter;